export const getUTCHours = (hours) => {
    const date = new Date();
    date.setHours(date.getUTCHours() + hours)
    return date;
}